module.exports = __webpack_public_path__ + "img/balkon11.b37c967f.jpg";